import React from "react";
import ReactDOM from "react-dom";
import { MemoryRouter } from "react-router-dom";
import { ChallengeProvider } from "@msidentity/SISU/challenge-reducer";
import { DfpIframe } from "@msidentity/SISU/components/device-finger-printing/dfp-iframe";
import Shell from "@msidentity/SISU/components/shell/fabric/shell-fabric";
import { Flavors, FlowId } from "@msidentity/SISU/constants";
import { BaseSisuProvidersFabric } from "@msidentity/SISU/context/sisu-providers";
import { UsernameRecoveryRoutesFabric } from "../../flows/username-recovery/fabric/username-recovery-flow-fabric";
import { initUsernameRecoveryConfig } from "../../flows/username-recovery/username-recovery-config";
import { UsernameRecoveryProvider } from "../../flows/username-recovery/username-recovery-context";
import { initUsernameRecoveryAppFabric } from "./init-username-recovery-app-fabric";

const serverData = window.ServerData || {};
const activeFlavor = Flavors.Fabric;
const activeFlow = FlowId.UsernameRecovery;

const { initialUsernameRecoveryState, initialChallengeState, initialProviderState } =
  initUsernameRecoveryAppFabric(serverData, activeFlavor, activeFlow);

initUsernameRecoveryConfig(serverData);

/**
 * Username Recovery fabric app
 * @returns a react component that renders Username Recovery flow
 */
export const UsernameRecoveryFabric: React.FC = function UsernameRecoveryFabric() {
  return (
    <React.StrictMode>
      <MemoryRouter>
        <BaseSisuProvidersFabric {...initialProviderState}>
          <Shell>
            <UsernameRecoveryProvider initialState={initialUsernameRecoveryState}>
              <ChallengeProvider initialState={initialChallengeState}>
                <UsernameRecoveryRoutesFabric />
                <DfpIframe />
              </ChallengeProvider>
            </UsernameRecoveryProvider>
          </Shell>
        </BaseSisuProvidersFabric>
      </MemoryRouter>
    </React.StrictMode>
  );
};

ReactDOM.render(<UsernameRecoveryFabric />, document.getElementById("root"));
